/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.1
 */

import produce from 'immer';
import { Reducer } from 'redux';

import {
    WIDGET_VOTING_LOAD_SURVEY,
    WIDGET_VOTING_LOAD_SURVEY_ERROR,
    WIDGET_VOTING_LOAD_SURVEY_SUCCESSFUL,
} from './constants/widgetVotingActionConstants';
import { widgetVotingInitialState } from './constants/widgetVotingConstants';
import { IWidgetVotingReducer } from './types/widgetVotingTypes';
import { TWidgetVotingActions } from './widgetVotingActions';


const widgetVotingReducer: Reducer<IWidgetVotingReducer, TWidgetVotingActions> =
    (state = widgetVotingInitialState, action: TWidgetVotingActions) =>
        produce(state, draft => {
            switch (action.type) {
                case WIDGET_VOTING_LOAD_SURVEY:
                    break;
                case WIDGET_VOTING_LOAD_SURVEY_SUCCESSFUL:
                    draft.data = action.payload;
                    break;
                case WIDGET_VOTING_LOAD_SURVEY_ERROR:
                    draft.error = action.payload.error;
                    break;
            }
        });

export default widgetVotingReducer;
